<template>
  <IconLucideFunnel />
</template>
